import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RespuestaAsistente } from 'src/app/services/ia/ia.service';
import { celda, decimalesDeColumna, nf, usd } from 'src/app/services/ia/ia-formato';

/**
 * UNA RESPUESTA DEL ASISTENTE, completa — para «Probar».
 *
 * El texto, y debajo lo que lo respalda (CONTRATO §6.4 y §8.1): la tabla que
 * calculó el compilador, los pendientes si es de ficha, las fichas que citó,
 * las pantallas del portal que ofrece y las sugerencias para seguir. Al pie, el
 * modelo y el costo, que en la consola sí se muestran (el comercio no los ve).
 *
 * 🔴 La tabla va SIEMPRE que la haya: el párrafo lo redactó un modelo y la tabla
 * la calculó el compilador, que es determinista. Si no dicen lo mismo, gana la
 * tabla, y sin ella nadie podría darse cuenta.
 *
 * 📍 Los enlaces vienen como DESTINO del portal (`/liquidaciones`), nunca como
 * dirección armada: aquí se muestran como texto, porque el portal es otra
 * aplicación y su dirección depende del comercio.
 */
@Component({
  selector: 'app-ia-respuesta',
  templateUrl: './ia-respuesta.component.html',
  styleUrls: ['./ia-respuesta.component.css']
})
export class IaRespuestaComponent {
  @Input() datos!: RespuestaAsistente;
  /** Una sugerencia tocada se vuelve la próxima pregunta. */
  @Output() preguntar = new EventEmitter<string>();

  readonly usd = usd;
  readonly nf = nf;

  readonly TIPOS: { [k: string]: string } = {
    cifras: 'Cifras', guia: 'Guía', ficha: 'Ficha del comercio', vivo: 'En vivo', nose: 'No lo sabe',
  };

  readonly PENDIENTE: { [k: string]: { texto: string; clase: string; icono: string } } = {
    falta: { texto: 'Falta', clase: 'kb-badge-alerta', icono: 'fa-exclamation-circle' },
    // §11.3: «pedido» = se lo pidió CrediTotal (ficha devuelta, sale de `profile_feedback`).
    pedido: { texto: 'Lo pidió CrediTotal', clase: 'kb-badge-alerta', icono: 'fa-undo' },
    ok: { texto: 'Listo', clase: 'kb-badge-exito', icono: 'fa-check-circle' },
  };

  /** Una columna es numérica si todo lo que tiene son números (o vacíos). */
  numerica = (i: number): boolean => {
    const filas = this.datos?.tabla?.filas || [];
    return filas.length > 0 && filas.every((f) => f[i] === null || typeof f[i] === 'number');
  };

  esNumero = (v: any): boolean => typeof v === 'number';

  /** El formato de cada columna, por su nombre y sus valores (ver `decimalesDeColumna`). */
  formato = (i: number): string => {
    const t = this.datos?.tabla;
    if (!t) return '1.0-0';
    return decimalesDeColumna(t.columnas[i], (t.filas || []).map((f) => f[i]));
  };

  readonly celda = celda;
}
